import styled from "styled-components";

import { onBackgroundImageSx } from "components/common/backgroundFrame";
import { CSS_VARIABLES } from "enums/cssVariables";

import {
    VOTEBOX_BORDER_WIDTH,
    VOTEBOX_CARD_RADIUS,
    VOTEBOX_FONT_SIZE_CAPTION,
    VOTEBOX_FONT_SIZE_SMALL,
    VOTEBOX_FONT_WEIGHT_BOLD,
    VOTEBOX_FONT_WEIGHT_SEMIBOLD,
    VOTEBOX_LINE_HEIGHT,
    VOTEBOX_SECONDARY_TEXT_COLOR,
} from "../../common/voteboxTokens";

// Panel applying one choice to all the deliberations.
export const APPLY_TO_ALL_PANEL_SX = {
    mb: 2,
    padding: "14px",
    border: `${VOTEBOX_BORDER_WIDTH} solid var(${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR})`,
    borderRadius: VOTEBOX_CARD_RADIUS,
    // Inside the frame, the panel shares the frame background instead of an opaque white one.
    ...onBackgroundImageSx({
        backgroundColor: "transparent",
    }),
};

export const Wrapper = styled.div`
    width: 100%;
`;

export const WrapperVote = styled.div`
    margin: auto;
    @media (max-width: 768px) {
        max-width: 350px;
    }
`;

// Headings for the structure only (RGAA 9.1): they keep the look of the former divs.
export const StyledGlobalTitle = styled.h1`
    margin: 0 0 1.5rem;
    font-size: ${VOTEBOX_FONT_SIZE_SMALL};
    font-weight: inherit;
`;

// Icon and title of the panel applying one choice to all the deliberations.
export const ApplyAllHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
`;

export const StyledApplyAllTitle = styled.h2`
    margin: 0;
    font-size: 1rem;
    font-weight: ${VOTEBOX_FONT_WEIGHT_BOLD};
    color: var(${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR});
`;
export const Icon = styled.img`
    width: 22px;
    height: 22px;
    margin-inline-end: 0.5rem;
`;
export const StyledNumberOfVoices = styled.div`
    color: ${VOTEBOX_SECONDARY_TEXT_COLOR};
    padding-bottom: 0.5rem;
    font-size: ${VOTEBOX_FONT_SIZE_SMALL};
`;
export const InfoMessage = styled.p`
    margin: 0;
    color: ${VOTEBOX_SECONDARY_TEXT_COLOR};
    font-size: ${VOTEBOX_FONT_SIZE_CAPTION};
    line-height: ${VOTEBOX_LINE_HEIGHT};
`;
export const SectionHeading = styled.div`
    margin: 1.5rem 0 1rem;
    color: ${VOTEBOX_SECONDARY_TEXT_COLOR};
    font-size: ${VOTEBOX_FONT_SIZE_CAPTION};
    font-weight: ${VOTEBOX_FONT_WEIGHT_BOLD};
    letter-spacing: 0.6px;
    text-transform: uppercase;
`;
export const Progress = styled.div`
    margin-top: 0.5rem;
    color: ${VOTEBOX_SECONDARY_TEXT_COLOR};
    font-size: ${VOTEBOX_FONT_SIZE_CAPTION};
    font-weight: ${VOTEBOX_FONT_WEIGHT_SEMIBOLD};
    text-align: center;
`;
